import { defineMessages } from 'react-intl';

export default defineMessages({
    uploadFilesMessage: {
        id: "platform.documentupload.templates.document-upload.Select Document",
        defaultMessage: "Select Document"
    }    
});
